import text_lang from '../translations/translations';

const TextSubmission = () =>{

    return(
        <div style={{textAlign:'center'}}>
            <h1>Thank you for your submit</h1>
            <h2>Now you can close this page</h2>
        </div>
    )
}

export default TextSubmission